import React, { createElement } from "react";

type Props = {
	tagName: string;
	htmlAttrs: {
		[key: string]: unknown;
	};
	children: React.ReactNode;
};
const Element: React.FC<Props> = ({ tagName, htmlAttrs, children }) =>
	createElement(tagName, htmlAttrs, children);

export default Element;
